export default "__VITE_ASSET__C1RHdaQ3__"